<template>
  <div>
    <headerSection></headerSection>
    <div class="reward-page" :style="pageBackgroundStyle">
      <div class="container reward-shell">
        <section class="reward-hero">
          <div class="reward-hero__panel">
            <p class="reward-hero__eyebrow">
              <i class="fas fa-history"></i>
              Transaction History
            </p>
            <h1 class="reward-hero__title">ประวัติธุรกรรม</h1>
            <p class="reward-hero__desc">
              รวมประวัติธุรกรรม โบนัส และกิจกรรมที่เกี่ยวข้องกับบัญชีของคุณไว้ในที่เดียว
              เพื่อดูการเคลื่อนไหวย้อนหลังได้ง่ายขึ้น
            </p>

            <div class="reward-chip-row">
              <span class="reward-chip">
                <i class="fas fa-list"></i>
                {{ history.length }} รายการ
              </span>
              <span class="reward-chip is-muted">
                <i class="fas fa-calendar-day"></i>
                ข้อมูลล่าสุด {{ latestTransactionLabel }}
              </span>
            </div>
          </div>

          <div class="reward-hero__panel reward-hero__panel--compact">
            <div class="reward-kv-list">
              <div class="reward-kv">
                <span class="reward-kv__label">ดำเนินการแล้ว</span>
                <span class="reward-kv__value">{{ successCount }}</span>
              </div>
              <div class="reward-kv">
                <span class="reward-kv__label">รอดำเนินการ / ยกเลิก</span>
                <span class="reward-kv__value">{{ pendingCount }}</span>
              </div>
              <div class="reward-kv">
                <span class="reward-kv__label">ยอดรวมในรายการ</span>
                <span class="reward-kv__value">{{ numberWithCommas(totalQty) }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="reward-section">
          <div class="reward-section__header">
            <div>
              <h2 class="reward-section__title">รายการล่าสุด</h2>
              <p class="reward-section__subtext">
                ตารางนี้รวมทั้งฝาก ถอน โบนัสวงล้อ รูเล็ต พันธมิตร ฝากต่อเนื่อง และคืนยอดเล่น
              </p>
            </div>
          </div>

          <div v-if="history.length" class="reward-table-card">
            <div class="reward-table-wrap">
              <table class="reward-table">
                <thead>
                  <tr>
                    <th>วัน/เวลา</th>
                    <th>ประเภท</th>
                    <th class="reward-table__number">จำนวน</th>
                    <th class="reward-table__center">สถานะ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in history" :key="index">
                    <td class="reward-table__strong">{{ item.createdateShow }}</td>
                    <td>
                      <span :class="['reward-badge', getTypeBadgeClass(item.type)]">
                        {{ item.type }}
                      </span>
                    </td>
                    <td class="reward-table__number">{{ numberWithCommas(item.qty) }}</td>
                    <td class="reward-table__center">
                      <span :class="['reward-badge', getStatusBadgeClass(item.status)]">
                        {{ getStatusText(item.status) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else class="reward-empty">
            <strong>ยังไม่มีประวัติธุรกรรม</strong>
            เมื่อมีการเคลื่อนไหวในระบบ รายการทั้งหมดจะมาแสดงในหน้านี้
          </div>
        </section>
      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
import _ from 'lodash'

export default {
  name: 'Promotion',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data () {
    return {
      history: []
    }
  },
  computed: {
    pageBackgroundStyle () {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(7, 13, 28, 0.32) 0%, rgba(7, 13, 28, 0.85) 100%), url(${require('../assets/images/Shiba-BG.jpg')})`
      }
    },
    successCount () {
      return this.history.filter(item => item.status === 'ดำเนินการแล้ว').length
    },
    pendingCount () {
      return this.history.length - this.successCount
    },
    totalQty () {
      return this.history.reduce((total, item) => total + Number(item.qty || 0), 0)
    },
    latestTransactionLabel () {
      return this.history.length ? this.history[0].createdateShow : 'ยังไม่มีข้อมูล'
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    getTypeBadgeClass (type) {
      if (type === 'ถอน') return 'is-danger'
      if (type === 'วงล้อ' || type === 'รูเล็ต' || type === 'ฝากต่อเนื่อง' || type === 'พันธมิตร' || type === 'คืนยอดเล่น') return 'is-info'
      return 'is-success'
    },
    getStatusBadgeClass (status) {
      if (status === 'ดำเนินการแล้ว') return 'is-success'
      if (status === 'ยกเลิก') return 'is-danger'
      return 'is-warning'
    },
    getStatusText (status) {
      if (status === 'ดำเนินการแล้ว') return 'สำเร็จ'
      if (status === 'ยกเลิก') return 'ยกเลิก'
      return 'รอดำเนินการ'
    }
  },
  async mounted () {
    this.scrollToTop()
    this.$store.commit('user/SET_LOADING', true)
    const user = this.getUserId()
    const history = []
    let lastdate = ''
    await firebase.firestore().collection('history').where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(500).get().then((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().qty) {
          const data = doc.data()
          data.key = doc.id
          data.createdateShow = moment(data.createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm')
          lastdate = data.createdate
          history.push(data)
        }
      })
    })
    await firebase.firestore().collection('spin').where('userkey', '==', user.key).where('createdate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'วงล้อ',
          createdate: doc.data().createdate,
          createdateShow: moment(doc.data().createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().value,
          status: 'ดำเนินการแล้ว'
        })
      })
    })

    await firebase.firestore().collection('roulet').where('userkey', '==', user.key).where('createdate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'รูเล็ต',
          createdate: doc.data().createdate,
          createdateShow: moment(doc.data().createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().value,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'ฝากต่อเนื่อง',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('partner_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'พันธมิตร',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('cashback_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'คืนยอดเล่น',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })

    this.history = _.orderBy(history, ['createdate'], ['desc'])
    this.$store.commit('user/SET_LOADING', false)
  }
}
</script>
